import React from "react"


export const getCarImage = (carModel: string) => {
    switch (carModel) {
      case "BYD E6":
        return "../../../images/carImages/byde6.jpg";
      case "BYD eMAX7":
        return "../../../images/carImages/BYDeMAX7.jpg";
      case "MG ZS":
        return "../../../images/carImages/MGZS.jpg";
      case "MG Windsor":
        return "../../../images/carImages/mgwindsor.jpeg";        
      case "Innova HyCross":
        return "../../../images/carImages/InnovaHycross.png";
      case "Kia Carens Clavis EV":
        return "../../../images/carImages/Kia_Carens1.jpg";
      default:
        return "";
    }
}

export const getCarModelImages: Record<string, string[]> = {
  "BYD E6": [
    "../../../images/carImages/BYD1.jpg",
    "../../../images/carImages/BYD3.jpg",
    "../../../images/carImages/BYD4.jpg",
    "../../../images/carImages/BYD5.jpg",
  ],
  "BYD eMAX7": [
    "../../../images/carImages/BYD_eMAX1.png",
    "../../../images/carImages/BYD_eMAX2.png",
    "../../../images/carImages/BYD_eMAX3.jpg",
  ],
  "MG ZS": [
    "../../../images/carImages/MGZS1.png",
    "../../../images/carImages/MGZS2.png",
    "../../../images/carImages/MGZS3.jpg",
  ],
  "MG Windsor": [
    "../../../images/carImages/mgwindsor.jpeg",
    "../../../images/carImages/mgwindsor2.jpeg",
    "../../../images/carImages/mgwindsor3.jpeg",
    "../../../images/carImages/mgwindsor4.jpeg",
  ],
  "Innova HyCross": [
    "../../../images/carImages/InnovaHyCross1.jpg",
    "../../../images/carImages/InnovaHyCross2.jpg",
    "../../../images/carImages/InnovaHyCross3.jpg",
    "../../../images/carImages/InnovaHyCross4.jpg",
  ],
  "Kia Carens Clavis EV": [
    "../../../images/carImages/Kia_Carens1.jpg",
    "../../../images/carImages/Kia_Carens2.jpg",
    "../../../images/carImages/Kia_Carens3.jpg",
  ],
};

export const getDiscountImage = (discountType: string) => {
    switch (discountType) {
        case "firstTimeBooking":
            return "../../../images/discount/discount-2.jpg";
        case "LastMinuteFare":
            return "../../../images/discount/discount-3.jpg";
        default:
            return "../../../images/discount/discount-1.jpg";
    }
}